import { Typography } from "antd";
import { intro, lastUpdated, legalTitle, sectionBody, sectionHeading } from "../LegalPage.styles.ts";

const { Title, Paragraph, Text } = Typography;

export const ImpressumBg = () => (
  <article>
    <Title className={legalTitle} level={1}>
      Юридическа информация
    </Title>
    <Text className={lastUpdated}>Информация по чл. 4 от Закона за електронната търговия</Text>

    <Paragraph className={intro}>
      Информацията по-долу идентифицира оператора на услугата Calculabel (calculabel.com и свързаните домейни) и се
      предоставя в изпълнение на задълженията за разкриване по Закона за електронната търговия и Директива 2000/31/ЕО за
      електронната търговия.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      Данни за дружеството
    </Title>
    <div className={sectionBody}>
      <ul>
        <li>
          <strong>Наименование:</strong> Фууд Сейфти Консултинг ЕООД
        </li>
        <li>
          <strong>Правна форма:</strong> Еднолично дружество с ограничена отговорност (ЕООД)
        </li>
        <li>
          <strong>ЕИК:</strong> 204435984
        </li>
        <li>
          <strong>ДДС №:</strong> BG204435984
        </li>
        <li>
          <strong>Седалище и адрес на управление:</strong> ул. Тракия № 34, 1527 София, България
        </li>
        <li>
          <strong>Регистрация:</strong> Търговски регистър към Агенция по вписванията на Република България
        </li>
      </ul>
    </div>

    <Title className={sectionHeading} level={4}>
      Контакти
    </Title>
    <div className={sectionBody}>
      <ul>
        <li>
          <strong>Имейл:</strong> <a href="mailto:support@calculabel.com">support@calculabel.com</a>
        </li>
        <li>
          <strong>Уебсайт:</strong> <a href="https://calculabel.com">calculabel.com</a>
        </li>
      </ul>
    </div>

    <Title className={sectionHeading} level={4}>
      Дейност
    </Title>
    <Paragraph className={sectionBody}>
      Опериране на платформата Calculabel — софтуер като услуга (SaaS) за управление на рецепти и съставки, изчисляване
      на хранителни стойности, генериране на хранителни и винени етикети, QR-етикети, проследяване на покупки и
      планиране на хранения.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      Онлайн решаване на спорове
    </Title>
    <Paragraph className={sectionBody}>
      Съгласно Регламент (ЕС) № 524/2013 Европейската комисия предоставя платформа за онлайн решаване на спорове:{" "}
      <a href="https://ec.europa.eu/consumers/odr">ec.europa.eu/consumers/odr</a>. Не сме длъжни и не поемаме
      предварителен ангажимент за участие в алтернативно решаване на спорове пред орган за помирение.
    </Paragraph>

    <Title className={sectionHeading} level={4}>
      Надзорен орган за лични данни
    </Title>
    <Paragraph className={sectionBody}>
      Комисия за защита на личните данни (КЗЛД)
      <br />
      бул. „Проф. Цветан Лазаров“ № 2, 1592 София, България
      <br />
      <a href="https://www.cpdp.bg">www.cpdp.bg</a>
    </Paragraph>
  </article>
);
